"use client";
import type * as Yup from "yup";
import { createContext } from "react";

interface SchemaContext {
  schema: Yup.ObjectSchema<any>;
  completeResource: any;
}
export const SchemaContext = createContext<SchemaContext>({} as SchemaContext);
